"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldCheck, Sparkles, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Authentication() {
  return <section data-section-id="70292" id="登录-web-端" className="relative min-h-screen flex items-center justify-center bg-background text-foreground p-4 overflow-hidden">
            {}
            <div className="absolute top-[-10%] left-[-10%] w-[40vw] h-[40vw] bg-emerald-500/10 rounded-full blur-[100px] opacity-50 pointer-events-none" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-sky-500/10 rounded-full blur-[100px] opacity-50 pointer-events-none" />
            <div className="absolute top-[20%] right-[10%] w-[20vw] h-[20vw] bg-amber-500/10 rounded-full blur-[80px] opacity-40 pointer-events-none" />

            <div className="w-full max-w-md relative z-10">
                <FormProvider formKey="login_form_online_app" formId="login_form_online_app" sectionName="authentication" defaultValues={{
        action: "Register a new account",
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        age: "",
        terms_agreement: false,
        login_identifier: "",
        login_password: ""
      }} submitText="进入在线精听" successMessage="登录成功！欢迎回到听力通，开启今日精听之旅。">
                    <AuthFormContent />
                </FormProvider>
            </div>
        </section>;
}
function AuthFormContent() {
  const {
    isSubmitted,
    successMessage,
    resetForm
  } = useWvcForm();
  if (isSubmitted) {
    return <Card className="bg-card/80 backdrop-blur-2xl border-border/50 shadow-2xl rounded-3xl overflow-hidden">
                <div className="h-2 w-full bg-gradient-to-r from-emerald-500 via-sky-400 to-emerald-600" />
                <CardContent className="pt-12 pb-8 flex flex-col items-center text-center space-y-4">
                    <div className="size-16 rounded-full bg-emerald-500/10 flex items-center justify-center mb-4">
                        <CircleCheck className="size-8 text-emerald-600" />
                    </div>
                    <CardTitle className="text-2xl font-bold tracking-tight">登录成功</CardTitle>
                    <CardDescription className="text-base text-muted-foreground">{successMessage}</CardDescription>
                    <Button onClick={resetForm} variant="outline" className="mt-6 w-full rounded-2xl border-emerald-200 hover:bg-emerald-50 text-emerald-700">
                        返回首页
                    </Button>
                </CardContent>
            </Card>;
  }
  return <Card className="bg-card/90 backdrop-blur-2xl border-border/50 shadow-[0_20px_50px_rgba(0,0,0,0.05)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.3)] rounded-[2rem] overflow-hidden relative group">
            {}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-emerald-500 via-sky-400 to-emerald-600 opacity-90" />
            
            <CardHeader className="space-y-2 pb-4 pt-10 text-center">
                <div className="mx-auto bg-emerald-500/10 p-3.5 rounded-2xl w-fit mb-3 ring-1 ring-emerald-500/20">
                    <ShieldCheck className="size-7 text-emerald-600" />
                </div>
                <CardTitle className="text-3xl font-bold tracking-tighter text-foreground">听力通</CardTitle>
                <CardDescription className="text-muted-foreground font-medium">AI 逐句精听，让你的耳朵真正醒过来</CardDescription>
            </CardHeader>

            <div className="flex justify-center items-center gap-4 -mt-4 mb-2">
                <Link to="https://app.listenmaster.cloud/login" newTab className="text-sm font-bold text-emerald-600 hover:text-emerald-500 transition-colors underline underline-offset-4 decoration-emerald-500/30 hover:decoration-emerald-500">
                    登录
                </Link>
                <div className="w-1 h-1 rounded-full bg-border" />
                <Link to="https://app.listenmaster.cloud/register" newTab className="text-sm font-bold text-emerald-600 hover:text-emerald-500 transition-colors underline underline-offset-4 decoration-emerald-500/30 hover:decoration-emerald-500">
                    免费注册
                </Link>
            </div>

            <CardContent className="px-8 pb-10">
                <div className="space-y-6">
                    {}
                    <div className="pt-6 mt-8 border-t border-border/40">
                        <Button asChild className="w-full h-14 rounded-2xl text-lg font-bold relative overflow-hidden group/btn border-0 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-[0_8px_20px_rgba(16,185,129,0.25)] hover:shadow-[0_12px_25px_rgba(16,185,129,0.35)] transition-all duration-300">
                            <Link to="https://app.listenmaster.cloud/login" newTab className="flex items-center justify-center w-full h-full">
                                {}
                                <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent opacity-0 group-hover/btn:opacity-100 transition-opacity" />
                                
                                <Sparkles className="mr-2 size-5 opacity-90" />
                                进入在线精听
                            </Link>
                        </Button>
                    </div>
                </div>
            </CardContent>
        </Card>;
}